import React, { useEffect,useState } from "react";
import "./EmploymentVerification.css";
import RadioNoButtons from "./RadioNoComponent";
import RadioYesComponent from "./RadioYesComponent";
import CandidateTab from "../CandidateTab";
import Sidebar from "../Sidebar";
import Header from "../Header";
import { useDispatch, useSelector } from "react-redux";
import ClientHeader from "../Partials/ClientHeader";
import ClientSideBar from "../Partials/ClientSideBar";
import NotificationPanels from "../NotificationPanels";
import { getInstantUan } from "../../Actions/uanActions";
import Loader from "../Common/loader";
import StepCount from "../Common/StepCount";
import ProgressHeading from "../Common/ProgressHeading";

const EmploymentVerification = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [role,setRole]=useState();
  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;
  const [noReason, setNoReason] = useState('');
  const [uanNo, setUanNo] = useState('');
  const [checkCompleted, setCheckCompleted] = useState(false);
  const [gapObject, setGapObject] = useState({});
  const [showProfilePreview, setShowProfilePreview] = useState(false);
  const [manualChange, setManualChange] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    const fetchData = async () => {

      dispatch(getInstantUan(callbackEditflow));
    };

    fetchData();
  }, []);

  const callbackEditflow = (data) => {
    console.log(data?.data?.checksDetails?.[0]?.fields);
    let fields = Object.values(data?.data?.checksDetails?.[0]?.fields);
    fields.map((field) => {
      if(field.id == '493'){
        if(field.field_value== 'Yes') setSelectedOption('yes');
        if(field.field_value == 'No') setSelectedOption('no');  
      }else
      if(field.id == '494'){
        setNoReason(field.field_value);
      }else if(field.id == '151'){
        setUanNo(field.field_value);
      }else if(field?.total_gap){
        setGapObject(field);
      }
    })
    setShowProfilePreview(data?.data?.showProfilePreview);
  }

  const landingStore = useSelector((state)=> state.landingPage)
  const {Data} = landingStore;

  useEffect(() => {
    if(Data){
      console.log(Data?.data?.totalGroupsOfChecks);
      // if(){
        // let allChecks = Object.values(Data?.data?.totalGroupsOfChecks);
        let allChecks = Data?.data?.totalGroupsOfChecks;
        if(allChecks != undefined){
          allChecks.map((check) => {
            if(check.name == "Employment Via UAN" && check.completed == "1"){
              setCheckCompleted(true);
            }
          })
        }
      }
    // }
  },[Data,landingStore])

  const [isLoading, setIsLoading] = useState(false);
  const storeData = useSelector((state) => state.uan);
  const { uanData, loading } = storeData;
  useEffect(() => {
    if (typeof loading !== "undefined" && loading !== null) {
      if (loading === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }
    }
  }, [uanData]);
  console.log(uanData)

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    setManualChange(true);
  };

  return (
    <>
    {isLoading && <Loader />}
    <NotificationPanels />
    {role=="EP"? <ClientHeader />:<Header/>}
    {role=="EP"? <ClientSideBar /> :<Sidebar/>}
    <section
      className="main-section candidate-tab-form"
      style={{ maddingTop: "60px" }}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-auto w-100-mbl bg-gray-mbl">
            <ProgressHeading/>
            <CandidateTab
             activeTab={"Employment Via UAN"}
            />
          </div>
          <div className="col bg-gray-mbl">
          <div
        className="w-100 h-100"
        style={{ background: "var(--gray-50, #F9FAFB)" }}
      >
        <div className="col">
          <div>
            <div
              className="card-header p-0 pb-3"
              style={{ background: "var(--gray-50, #F9FAFB)" }}
            >
              <StepCount activeTab={"Employment Via UAN"} />
              <div className="card-header-main">Employment Verification</div>
              <div className="card-header-sub">
                Please give/upload required information
              </div>
            </div>
            <div
              className="card-body p-0"
              style={{ background: "var(--gray-50, #F9FAFB)" }}
            >
              <div className="container-fluid mt-4 p-0">
                <div className="card-text">Do you have UAN no.?<sup className="text-danger">{' '}*</sup></div>
                <div className="d-flex justify-content-start align-items-center">
                  <div className="form-check d-flex justify-content-between align-items-center px-4 py-2">
                    <input
                      type="radio"
                      id="yesOption"
                      className="form-check-input p-2"
                      name="options"
                      checked={selectedOption === "yes"}
                      onChange={() => handleOptionChange("yes")}
                      disabled={checkCompleted}
                    />
                    <label
                      className="form-check-label pl-2"
                      style={{ paddingTop: "3px" }}
                      htmlFor="yesOption"
                    >
                      Yes
                    </label>
                  </div>

                  <div className="form-check d-flex justify-content-between align-items-center px-4 py-2">
                    <input
                      type="radio"
                      id="noOption"
                      className="form-check-input p-2"
                      name="options"
                      checked={selectedOption === "no"}
                      onChange={() => handleOptionChange("no")}
                      disabled={checkCompleted}
                    />
                    <label
                      className="form-check-label pl-2"
                      style={{ paddingTop: "3px" }}
                      htmlFor="noOption"
                    >
                      No
                    </label>
                  </div>
                </div>

                {selectedOption === "no" && (
                  <div className="mt-3">
                    <RadioNoButtons 
                      formData={uanData?.data?.data}
                      noReason={noReason}
                      checkCompleted={checkCompleted}
                      gapObject={gapObject}
                      showProfilePreview={showProfilePreview}
                      manualChange={manualChange}
                    />
                  </div>
                )}

                {selectedOption === "yes" && (
                  <div className="mt-3">
                    <RadioYesComponent 
                    formData={uanData?.data?.data}
                    uanNumber={uanNo}
                    checkCompleted={checkCompleted}
                    gapObject={gapObject}
                    flow="Yes"
                    showProfilePreview={showProfilePreview}
                    manualChange={manualChange}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
          </div>
        </div>
      </div>
    </section>
      
    </>
  );
};

export default EmploymentVerification;
